/**
 * Images that ship with the site (public/images).
 * Shown in the admin image picker alongside anything you upload.
 * If you add files to public/images by hand, add them here too so they appear
 * in the picker - uploads made through the admin appear automatically.
 */
export const IMAGE_LIBRARY = [
    '/images/Briefing-Planning.png',
    '/images/British-Manufacture.png',
    '/images/British-Wool.png',
    '/images/Cost-Optimisation.png',
    '/images/Design-and-Development.jpg',
    '/images/Development-Programming.png',
    '/images/Faster-Turn-Around.png',
    '/images/Finishing-QC.png',
    '/images/Home-Page.jpg',
    '/images/INTRO PAGE.jpg',
    '/images/Larger-Volumes.png',
    '/images/Made-in-London.jpg',
    '/images/Natural-Fibres.png',
    '/images/Our-Values.jpg',
    '/images/Overseas-Production.jpeg',
    '/images/Portfolio.jpg',
    '/images/Precision+Quality.png',
    '/images/Production.png',
    '/images/Recycle-Yarn.png',
    '/images/Sustainable-Practices.png',
    '/images/Yarn-Shop.jpg',
    '/images/aysen-portrait.jpg',
    '/images/bespoke-knitwear.jpg',
    '/images/concept-dev.png',
    '/images/emma-portrait.jpg',
    '/images/hero.gif',
    '/images/hero.jpg',
    '/images/initial-consultation.png',
    '/images/logo-stitches.png',
    '/images/logo.png',
    '/images/manfactoring+delivery.png',
    '/images/portfolio-1.jpg',
    '/images/portfolio-2.jpg',
    '/images/portfolio-3.jpg',
    '/images/portfolio-4.jpg',
    '/images/portfolio-5.jpg',
    '/images/portfolio-6.jpg',
    '/images/portfolio-7.jpg',
    '/images/portfolio-8.jpg',
    '/images/portfolio-9.jpg',
    '/images/production+approval.png',
    '/images/sampling+iteration.png',
    '/images/sustainable-production.jpg',
    '/images/wool.svg'
];
